<header class="qr-header" data-cy="qr-building-header">
  <div class="qr-header-top">
    @if (context.isExternal()) {
      <button nbButton ghost size="tiny" status="basic" class="qr-all-buildings"
              data-cy="qr-all-buildings" (click)="openAllBuildings()">
        <nb-icon icon="arrow-back-outline" pack="eva"></nb-icon>
        Alle Gebäude
      </button>
      @if (context.buildingInfo(); as info) {
        <span class="qr-building-name" data-cy="qr-building-name">{{ info.buildingName }}</span>
      }
    }
    <span class="qr-address" data-cy="qr-header-address">{{ context.section()?.buildingSectionAddress }}</span>
  </div>
  <nav class="qr-tabs">
    @for (link of tabs(); track link.tab) {
      <button class="qr-tab"
              [class.qr-tab--active]="link.tab === active()"
              [attr.data-cy]="link.dataCy"
              (click)="navigate(link.tab)">
        <nb-icon [icon]="link.icon" pack="fas"></nb-icon>
        <span>{{ link.label }}</span>
      </button>
    }
  </nav>
  @if (selectableSections().length > 0) {
    <div class="qr-sections" data-cy="qr-section-select">
      @for (section of selectableSections(); track section.id) {
        <button class="qr-section"
                [class.qr-section--active]="section.id === context.sectionId()"
                data-cy="qr-section-option"
                (click)="context.selectSection(section.id)">
          {{ section.buildingSectionAddress }}
        </button>
      }
    </div>
  }
</header>
